import { memo } from "react";
import { formattedDateTimeWithoutSec } from "../../../lib/functions";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface RequestDetailsProps {
    permitDetails: {
        requestedServices: {
            serviceNameEn: string;
        }[];
        s_OfficeNumber: string;
        dt_RequestDate: any;
    } | null;
}

const RequestDetails = ({
    permitDetails,
}: RequestDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 2: Request Details
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Requested Services:"
                    value={permitDetails?.requestedServices.map(service => service.serviceNameEn).join(", ") || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Request Date:"
                    value={formattedDateTimeWithoutSec(permitDetails?.dt_RequestDate) || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Office Number:"
                    value={permitDetails?.s_OfficeNumber || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label=""
                    value=""
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />

            </div>
        </div>
    );
};

export default memo(RequestDetails);
